import { useUser, useClerk } from '@clerk/clerk-react'
import { useSearchParams } from 'react-router-dom'

export default function WaitlistPage() {
  const { user } = useUser()
  const { signOut } = useClerk()
  const [searchParams] = useSearchParams()
  const checkoutSuccess = searchParams.get('checkout') === 'success'

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background px-4">
      <div className="mx-auto max-w-md text-center">
        <div className="mb-6 text-5xl">{checkoutSuccess ? '🎉' : '⏳'}</div>
        <h1 className="mb-4 text-3xl font-bold tracking-tight">
          {checkoutSuccess ? "You're in!" : "You're on the waitlist!"}
        </h1>
        <p className="mb-6 text-lg text-muted-foreground">
          {checkoutSuccess
            ? 'Your early access spot is locked in with 30% off — forever.'
            : 'We\'ll notify you when we launch.'}
        </p>

        <div className="rounded-lg border bg-card p-6 text-left">
          <h2 className="mb-2 font-semibold">What happens next?</h2>
          <ul className="space-y-2 text-sm text-muted-foreground">
            {checkoutSuccess ? (
              <>
                <li>Your card is saved but will NOT be charged yet</li>
                <li>On launch day, your Pro plan activates automatically</li>
                <li>You'll be charged $104.30/month (30% off forever)</li>
                <li>We'll email you before your first charge</li>
              </>
            ) : (
              <>
                <li>Your account has been created</li>
                <li>You'll get 30% off when we launch</li>
                <li>No action needed on your end</li>
              </>
            )}
          </ul>
        </div>

        <p className="mt-6 text-sm text-muted-foreground">
          Signed up as{' '}
          <span className="font-medium text-foreground">
            {user?.primaryEmailAddress?.emailAddress}
          </span>
        </p>

        <button
          onClick={() => void signOut()}
          className="mt-4 text-sm text-muted-foreground underline hover:text-foreground"
        >
          Sign out
        </button>
      </div>
    </div>
  )
}
